/** Layout tokens for the personas detail mini-timeline track and bars. */

export const TRACK_HEIGHT_PX = 18;
export const TRACK_BORDER_PX = 1;
export const BAR_HEIGHT_PX = 10;

/** Center bars in the content box (height includes borders via border-box). */
export const BAR_TOP_PX = (TRACK_HEIGHT_PX - 2 * TRACK_BORDER_PX - BAR_HEIGHT_PX) / 2;
